<ng-template #itemTemp let-r="result" let-t="term">
  <div>
    <ngb-highlight
      [result]="
        r.CustomerTypeId == 2 ? r.BusinessName : r.FirstName + ' ' + r.LastName
      "
      [term]="t"
    ></ngb-highlight>
  </div>
</ng-template>
<input
  id="itemTypeAhead"
  [disabled]="itemBusy"
  [editable]="false"
  type="text"
  autocomplete="off"
  class="form-control form-control-sm"
  [inputFormatter]="formatter"
  [resultFormatter]="formatter"
  placeholder="Search customer"
  [resultTemplate]="itemTemp"
  [ngbTypeahead]="search"
  (selectItem)="onItemSelect($event.item)"
  #itemTypeAhead
/>
